import { EInvoiceSenderComplianceMessage } from "bookkeeping/detail/EInvoiceSenderComplianceMessage";
import React from "react";

export const BookkeepingNotRegisteredForPeppol = () => {
  return <EInvoiceSenderComplianceMessage
    compliance={{
      value: "notRegisteredReferToBookkeepingPage",
      message: RESX.EInvoicing.EInvoicingIsNotActivated,
      messageSublabel: RESX.EInvoicing.GoToTheBookkeepingForMoreInformation
    }}
  />
}